import { companyValues } from '../../utils/data';
import SectionHeader from '../common/SectionHeader';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

export default function WhyUsSection() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader
          eyebrow="Why Choose Us"
          title="The Anir Healthcare Difference"
          subtitle="We combine scientific rigor with compassionate care to deliver pharmaceutical products that truly make a difference."
        />

        <div
          ref={ref}
          className={`grid grid-cols-1 md:grid-cols-2 gap-6 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {companyValues.map((value, i) => (
            <div
              key={value.title}
              className="flex gap-5 p-6 bg-gradient-to-br from-blue-50 to-white rounded-2xl border border-blue-100 hover:border-blue-200 hover:shadow-card transition-all duration-300"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="flex-shrink-0 w-14 h-14 bg-white rounded-xl shadow-sm flex items-center justify-center text-3xl">
                {value.icon}
              </div>
              <div>
                <h3 className="font-display font-bold text-primary-800 text-lg mb-1">
                  {value.title}
                </h3>
                <p className="text-slate-500 text-sm leading-relaxed">{value.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
